var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "container", attrs: { id: "app" } }, [
    _c(
      "div",
      { staticClass: "pageBg" },
      [
        _vm.pageWidth == "1336px" ? _c("pageTop") : _vm._e(),
        _vm._v(" "),
        _vm.pageWidth == "1336px"
          ? _c("div", { staticClass: "pageTop" }, [
              _c("img", {
                staticClass: "bigBg",
                attrs: {
                  src: require("../src/assets/imgs/topBg.png"),
                  alt: "",
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              margin: "0 auto",
              "min-height": "80vh",
              padding: "0 18px",
              "box-sizing": "border-box",
            },
            style: { width: _vm.pageWidth },
          },
          [_c("router-view")],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }